const sw = {
    text: {
        search: 'Tafuta',

        login_title: 'Ingia',
        loginaccount_title: 'Ingia',
        login_btn_login: 'Ingia na Barua Pepe au Namba ya Simu',
        login_tip: 'Soma na kukubali',
        login_tip_privacy_policy: 'Sera ya Juu ya Haki za Mtumiaji',
        login_tip_and: 'na',
        login_tip_service_rules: 'Sera ya Huduma',
        login_not_have_account: 'Hujana Akaunti?',
        login_btn_register: 'Jisajili',
        login_msg: 'Tafadhali kubali na kuchochea Sera ya Juu ya Haki za Mtumiaji wa Senda na Mfumo wa Huduma.',
        registered_cna: 'Jenga Akaunti Mpya',
        registered_phn: 'Namba ya Simu',
        registered_cfn: 'Thibitisha Namba',
        registered_etc: 'Ingiza kodi iliyotumwa kwa',
        registered_snc: 'Tuma kodi mpya',
        registered_vfc: 'Kodi ya Thibitisho',
        registered_spa: 'Wezesha Nenosiri',
        registered_cht: 'herufi',
        registered_gtl: 'Nenda kufungua kiriti',
        registered_ath: 'Nenda kwenye Nyumbani',

        registered_wrtyt: 'Ujasajili ulifanikiwa',
        registered_wokjt: 'kinaenda kiotomatiki kwenye ukurasa wa kuingia',
        login_fail: 'Kuingia kushindwa',
        login_fail_tip: 'Akaunti au nenosiri sio sahihi. Tafadhali ingiza tena',
        verification_code_error: 'Kodi ya thibitisho si sahihi',
        successful_gtt: 'Kurekebisha nenosiri kulifanikiwa',
        perfect_qwer: 'Chagua nambari ya nchi',
        perfect_tyui: 'Chagua nchi',
        perfect_qsde: 'Chagua Mkoa',
        information_mne: 'Kuchagua Jinsia',
        perfect_oill: 'Maarifa yamekamilika',
        perfect_nnmj: 'sekunde kinaenda kiotomatiki kwenye duka kuchambua',
        perfect_ndyy: 'Peleka kwenye duka kuchambua',
        able_iju: 'Kipengele cha kuchambua sasa haukuwana matokeo, jaribu kubadili ~',
        able_wer: 'Hakuna data inayohusiana',
        vori_sdw: 'Kufuta kuchambua kulifanikiwa',
        entif_oiu: 'Katika mchakato wa kuchambua',
        scan_for_qr_code: 'Piga Kodi ya QR',
        scan: 'Piga picha',
        switch_camera: 'Badilisha Kamera', // 切换摄像头
        up_suu: 'Kuitia nje',
        up_swu: 'Thibitisha kuitia nje?',
        up_slu: 'Akaunti imeitishwa nje',
        seguridad_kja: 'Thibitisha kutoa kumbukumbu?',
        seguridad_siu: 'Baada ya kuchochea',
        seguridad_siu2: 'haiwezi tena kutumika kuingia kwenye akaunti hii',
        browse_xccfv: 'Kufanya uajiri wa huduma',
        browse_erty: 'Usifanye uajiri',
        browse_bngh: 'Kufanya uajiri',
        did_wwe: 'Kuingiza kulifanikiwa',
        calculate_mnrt: 'Tafadhali chagua rekodi ya kihesabu',
        ping_joi: 'Thibitisha kuchafua rekodi?',
        ping_jki: 'Imeufanyika kikamilifu',
        ppn_oghs: 'Imegoverned kikamilifu',
        empty_ccr: 'Je! Una makosa kuchafua vipengele vya kihesabu? Vipengele vya kihesabu vilivyofutwa vinaweza kuzaliwa tena kutoka kwenye kuchafua hapo juu.',
        supprime_cgd: 'Je! Una makosa kuchafua kabla vipengele vya kihesabu? Operesheni hii haiwezi kurudishwa.',
        empty_ctl: 'thibitisha kuchafua rekodi hii?',

        // 新增或缺失的翻译（去重并备注原始中文）
        tiles_sanitary: "Tiles & Ware usafi",
        view: "Tazama",
        real_case: "Kesi za Kweli",
        see_all: "Tazama Zote",
        appointment: "Miadi",
        distance: "km kutoka kwako",
        unable_to_locate: "Haiwezi kuchambua",
        brand: "Chapa",
        collections: "Mikusanyiko",
        login_successful: "Umeingia kwa Mafanikio",
        search: "Tafuta",
        home: "Mwanzo",
        display: "Mwonekano",
        cases: "Kesi",
        account: "Akaunti",

        recommend_chrome: "Inapendekezwa kutumia kivinjari cha Chrome kufikia jukwaa",
        not_chrome_use_chrome: "Kwa sasa unatumia kivinjari kisicho Chrome, tafadhali tumia Google Chrome kwa matumizi bora zaidi",

        products: "Bidhaa",
        popular: "Maarufu",
        popular_searches_hidden: "Utafutaji maarufu wa sasa umefichwa",
        confirm_show_all_history: "Onyesha rekodi zote za kihistoria?",
        search_for_all: "Tafuta zote",
        bathroom: "Bafu",
        search_brand_info: "Tafuta taarifa za chapa",
        search_space: "Tafuta kwa nafasi",
        non_slip_tile: "Vigae visivyoteleza",
        please_enter_content: "Tafadhali ingiza maudhui",
        no_relevant_results: "Kwa bahati mbaya, hakuna matokeo yanayofaa yaliyopatikana",
        try_searching: "Jaribu kutafuta tena",
        more_products: "Vifaa Zaidi",
        more_cases: "Vikesi Zaidi",

        search_for_store: "Tafuta Duka",
        store_appointment: "Miadi ya Dukani",
        other_stores: "Maduka Mengine",
        loading_complete: "Upakiaji Umekamilika",
        loading: "Inapakia...",
        search_store: "Tafuta Duka",
        nearby_stores: "Maduka ya Karibu",
        select_store: "Chagua Duka",
        cancel: "Ghairi",
        history: "Historia",
        artificial_service: "Huduma ya Kiotomatiki",
        online_service: "Huduma ya Mtandao",

        product_not_exist: "Huduma ya Bidhaa Hapa Nao Hii", // 原文: 产品不存在
        product_offline: "Huduma ya Bidhaa Hapa Nao Hii", // 产品已下架

        amount: "Kiasi",
        appointment_info: "Taarifa za Miadi",
        service_evaluation: "Uajiri wa Huduma",
        remarks: "Maoni",
        enter_additional_comments: "Ingiza maoni ya ziada",
        monday: "Jumatatu",
        tuesday: "Jumanne",
        wednesday: "Jumatano",
        thursday: "Alhamisi",
        friday: "Ijumaa",
        saturday: "Jumamosi",
        sunday: "Jumapili",
        MON: "JUM",
        TUE: "JUM",
        WED: "JUM",
        THU: "ALH",
        FRI: "IJU",
        SAT: "JUM",
        SUN: "JUM",
        to: "kwa",

        please_input: "Tafadhali ingiza",
        please_select: "Tafadhali chagua",
        please_enter_your_needs: "Tafadhali ingiza mahitaji yako",
        appointment_time: "Muda wa Miadi",
        date: "Tarehe",
        required_fields_not_selected: "Sehemu za lazima hazijachaguliwa",
        time: "Muda",
        information: "Taarifa",
        name: "Jina",
        first_name: "Jina la kwanza",
        last_name: "Jina la mwisho",
        gender: "Jinsia",
        male: "Mwanaume",
        female: "Mwanamke",
        contact: "Mawasiliano",
        demand: "Ombi",
        phone: "Simu",
        obtain: "Pata",
        submit: "Wasilisha",
        confirm: "Thibitisha",
        next: "Ijayo",
        back: "Nyuma",

        sort_by: "Panga kwa",
        filter: "Chuja",
        reset: "Weka upya",
        default: "Chaguo-msingi",
        newest: "Mpya zaidi",
        trending: "Zinazovuma",
        apply: "Tumia",
        basic_colors: "Rangi za Msingi",
        marble_stone: "Marumaru na Jiwe",
        download_app_3d: "Pakua programu ili kuona athari ya 3D",
        showroom_products: "Bidhaa za Maonyesho",
        matching_records: "Matokeo Yanayolingana",
        recognize_qr_code: "Changanua Msimbo wa QR",

        product_details: "Maelezo ya Bidhaa",
        renderings: "Michoro",
        related_cases_products_in_model_room: "Kesi Zinazohusiana / Bidhaa Zilizotumika kwenye Chumba cha Mfano",
        recommended_products: "Bidhaa Zinazopendekezwa",
        display_3d: "Onyesho la 3D",
        collection: "Mikusanyiko",
        basic_product_parameters: "Vigezo vya Msingi vya Bidhaa",
        functional_parameters: "Vigezo vya Kiutendaji",
        close: "Funga",
        share: "Kugawanya",
        info_to: "Maarifa Kwa",
        share_case_info_to: "Shiriki Taarifa za Kesi kwa",
        copy_link: "Nakili Kiungo",
        space: "Nafasi",
        download_app_tip: "Pakua programu ili kuona athari ya 3D",
        showroom_products: "Bidhaa za Maonyesho",

        log_in_with_account: "Ingia kwa Akaunti",
        you_are_logging_into_account_for: "Unaingia kwenye akaunti ya",
        select_country_again: "Ikiwa haupo katika nchi hii, tafadhali chagua tena.",
        registering_into_account_for: "Unafungua akaunti kwa",
        already_have_account: "Tayari una akaunti?",
        phone_number_verification: "Uthibitishaji wa Nambari ya Simu",
        accept_sms_verification_code: "Kwa kuthibitisha msimbo wa SMS",
        confirm_number: "Thibitisha Nambari",
        enter_code_sent_to: "Ingiza msimbo uliotumwa kwa",
        send_new_code: "Tuma msimbo mpya",
        verification_code: "Msimbo wa Uthibitishaji",
        reset_password: "Weka upya Nenosiri",
        other_login_method: "Njia Nyingine ya Kuingia",
        retrieve_password: "Rejesha Nenosiri",
        create_new_account: "Jenga Akaunti Mpya",
        retrieve_send_new_code: "Tuma msimbo mpya",
        retrieve_reset_password: "Weka upya Nenosiri",
        required_fields_not_selected: "Sehemu za lazima hazijachaguliwa",
        login_password_placeholder: "6+ herufi",
        // person page
        account: "Akaunti",
        shopping_list: "Orodha ya Manunuzi",
        wish_list: "Orodha ya Matamanio",
        no_favorite_yet: "Hakuna vipendwa bado",
        read_more: "Soma Zaidi",
        store_experience_records: "Historia ya Uzoefu wa Dukani",
        no_records_yet: "Hakuna Rekodi Bado",
        no_case_yet: "Hakuna Kesi Bado",
        share_give_gift: "Shiriki\nToa Zawadi",
        give_friend_gift: "Toa zawadi kwa rafiki yako na upewe zawadi pia",
        go: "Nenda!",
        my_cases: "Kesi Zangu",
        no_cases: "Hakuna Kesi",
        recently_viewed: "Zilizotazamwa Hivi Karibuni",
        tips: "Mashauri",
        switching_countries_re_register: "Guhagarika nchi inahitaji kuchambua tena akaunti yako",
        not_logged_in: "Hujaindika",
        no_data_yet: "Hakuna Data Bado",
        sort: "Tatua",
        browsing_type: "Aina ya Kuzungumzia",
        content: "Maudhui",
        last_view: "Tazama ya Mwisho",
        offline: "Offline",
        time_new_old: "Muda (mpya-zalim)",
        time_old_new: "Muda (zalim-mpya)",
        views_most_least: "Tazama (zaidi-wingi)",
        views_least_most: "Tazama (wingi-zaidi)",
        all: "Yote",
        online_browsing: "Kuzungumzia Online",
        offline_browsing: "Kuzungumzia Offline",
        product: "Vifaa",
        case: "Kesi",
        display: "Onyesha",
        set_up: "Wezesha",
        log_out: "Kuitia nje",
        personal_info: "Maarifa ya Mtu Binafsi",
        account_security: "Usalama wa Akaunti",
        first_name: "Jina la Kwanza",
        last_name: "Jina la Mwisho",
        enter_your_first_name: "Ingiza jina lako la kwanza",
        enter_your_last_name: "Ingiza jina lako la mwisho",
        location: "Mahali",
        select_country_province_city: "Chagua Nchi / Mkoa / Jiji",
        gender: "Jinsia",
        select_your_gender: "Chagua jinsia yako",
        male: "Mwanaume",
        female: "Mwanamke",
        language: "Lugha",
        select_language: "Chagua Lugha",
        english: "Kiingereza",
        french: "Kifaransa",
        user_info_changed_save: "Maarifa ya mtumiaji yamebadilika, kuhifadhi?",
        save_success: "Kuhifadhi Kufanikiwa",
        phone_info: "Maarifa ya Simu",
        phone: "Simu",
        third_party_account_binding: "Kuzungumzia Akaunti ya Kati ya Wataalamu wa Tatu",
        bind: "Zungumzia",
        unbind: "Toa Zungumzio",
        unbind_facebook_cannot_login: "Baada ya kuchochea Facebook, hautakuwa na uwezo wa kuchambua tena akaunti hii",
        information_complete: "Maarifa Yamekamilika",
        information_not_complete: "Maarifa hayakamiliki",
        login_password_requirement: "herufi kubwa, herufi ndogo, namba, angalau 6 herufi",
        your_phone_number: "Namba ya simu yako",
        password_requirement: "Nenosiri：6+ herufi",
        other_login: "Kuingia Kwingine",
        facebook: "Facebook",
        google: "Google",

        shopping_list: "Orodha ya Kununua",
        wish_list: "Orodha ya Tumaini",
        read_more: "Soma Zaidi",
        no_favorite_yet: "Hakuna Favoriti Bado",
        store_experience_records: "Rekodi ya Experience ya Duka",
        share: "Gawanya",
        give_a_gift: "Toa Zawadi",
        my_cases: "Vikesi Vya Kwangu",
        go: "Nenda!",
        no_cases: "Hakuna Vikesi",
        recently_viewed: "Tazama Hivi Karibuni",

        country_selection: "Uchaguzi wa Nchi",
        based_on_your_location: "Kulingana na eneo ulilopo,",
        auto_selected_country: "nchi imechaguliwa kwa ajili yako.",
        manual_select_country: "Ikiwa eneo ni lisilo sahihi, tafadhali chagua nchi yako kwa mkono.",
        switching_countries_requires_re_registering: "Kubadilisha nchi kunahitaji kuunda akaunti mpya, kwa hivyo tafadhali chagua kwa uangalifu.",

        select_all: "Chagua yote",
        remove: "Ondoa",
        finish: "Maliza",
        edit: "Hariri",
        saved: "Imesajiliwa",
        favourite: "Favoriti",
        confirm_clear_all_favorites: "Thibitisha kuondoa vipendwa vyote?",
        all: "Yote",

        my_appointment: "Miadi Yangu",
        store_record: "Rekodi ya Duka",
        purchase_history: "Historia ya Manunuzi",
        ongoing: "Inayoendelea",
        completed: "Imekamilika",
        considerate_service: "Huduma ya Hekima",
        attentive: "Makini",
        patience: "Subira",
        communicate_smoothly: "Mawasiliano Bila Shida",
        high_professional: "Mtaalamu Sana",
        bad_attitude: "Tabia Mbaya",
        service_appointment_details: "Maelezo ya Miadi ya Huduma",
        show_appointment_code: "Onyesha Msimbo wa Miadi",
        my_appointment_history: "Historia ya Miadi Zangu",
        back_to_home: "Rudi Mwanzo",
        appointment_code_expired: "Msimbo wa Miadi Umeisha",
        no_record: "Hakuna Rekodi",
        browse_records: "Pitia Rekodi",
        details: "Maelezo",
        product_list: "Orodha ya Bidhaa",
        no_browsing_history: "Hakuna Historia ya Kuangalia",
        purchase_history_detail: "Maelezo ya Historia ya Manunuzi",
        arrived: "Imefika",
        times: "Mara",
        payment_voucher: "Risiti ya Malipo",
        purchase_list: "Orodha ya Manunuzi",
        brick_units_are_boxes: "Vifaa vya vigae ni masanduku",
        store_service_appointment: "Miadi ya Huduma ya Dukani",
        thanks_for_appointment: "Asante kwa miadi！Tunatarajia ziara yako！",
        contact_shopping_guide: "Wasiliana na Mshauri wa Dukani",
        appointment_code: "Msimbo wa Miadi",
        show_to_shop_guider: "Onyesha kwa Mshauri wa Duka",
        go_to_shopping_list: "Nenda kwenye Orodha ya Manunuzi",
        service_appointment: "Miadi ya Huduma",

        location_failed: "Kushindwa Kupata Eneo",
        positioning: "Inapopatikana Eneo...",
        re_locate: "Pata Eneo Tena",
        current_location: "Mahali ya Sasa",
        search_for_city: "Tafuta jiji",

        case_details: "Maelezo ya Kesi",
        renderings: "Michoro",
        products_applied: "Bidhaa Zilitumika",
        uploader: "Imepakiwa na",
        related_cases: "Kesi Zinazohusiana",
        case: "Kesi",
        page_situation: "Hali ya Ukurasa",
        situation1: "1、Kifurushi cha tafuta hauchaguiwi kwa muda mfupi\n2、Interface ya kategoria ya kesi yana kosa ya mtandao\n3、Moduli ya kuchagua jiji inaawaita api ya kuthibitisha\n4、Button ya kuzungumzia hauchaguiwi\n5、Data ya orodha ya kesi ina missing keywords\n6、Parameta ya sort ya interface ya orodha ya kesi ina missing data nyingine",
        situation2: "1、Interface ya kuthibitisha maelezo haufanyi kazi\n2、Baru ya juu haijadhakika",
        situation3: "1、Sitaisho la duka la hivi karibuni\n2、Address ya video ya interface hauwezi kuzungumzia\n3、Data ya maelezo ina missing\n4、Icon ya mteja ina missing",

        calculator: "Kikokotoo",
        meter: "mita (m)",
        feet: "futi (ft)",
        system_calc_method: "Mbinu ya kukokotoa ya mfumo: 1 m² = 10,7639104167 sqft",
        add_products: "Ongeza bidhaa",
        add_from: "Ongeza Kutoka",
        t_collections: "Mikusanyiko",
        t_matching_records: "Matokeo Yanayolingana",
        t_favorites: "Favoriti",
        t_recently_viewed: "Zilizotazamwa Hivi Karibuni",
        select_space: "Chagua nafasi",
        wall: "Ukuta",
        floor: "Chumbu",
        continuous_laying: "Uwekaji endelevu",
        area: "Eneo",
        door: "Mlango",
        window: "Dirisha",
        pcs: "PCS",
        m2: "m²",
        sqft: "sqft",
        change_products: "Badilisha bidhaa",
        subtotal: "Jumla ndogo",
        box: "Boksi",
        no_record: "Hakuna rekodi",
        grand_total: "Jumla kuu",
        add_to_shopping_list: "Ongeza kwenye orodha ya manunuzi",
        add_from_collections: "Ongeza kutoka makusanyo",
        add_from_favorites: "Ongeza kutoka vipendwa",

        select_unit: "Chagua kitengo",
        please_select_space_first: "Tafadhali chagua nafasi kwanza",
        copied: "Imenakiliwa",
        deleted: "Imefutwa",
        clearing: "Inasafisha",
        saved_to_customer_view_pending_purchase_list: "Imehifadhiwa kwa mteja, unaweza kubofya kuona orodha ya manunuzi yanayosubiri",
        cannot_add_zero_box_products: "Bidhaa zenye boksi sifuri haziwezi kuongezwa kwenye orodha ya kununua",

        id_number: "Nambari ya kitambulisho",
        client: "Mteja",
        edited: "Imehaririwa",
        discount: "Punguzo",
        last_price: "Bei ya mwisho",
        favorite_successfully: "Imeongezwa kwenye vipendwa kwa mafanikio",
        success: "Mafanikio",
        unknown_current_region: "Eneo la sasa halijulikani",
        login_before_scan: "Tafadhali ingiza kwanza kabla ya kuchanganua ili kuona",
        invalid_qr_code: "Msimbo wa QR si halali",
        error_need_camera_permission: "Hitilafu: Unahitaji kuruhusu ufikiaji wa kamera",
        error_no_camera_detected: "Hitilafu: Hakuna kamera iliyogunduliwa",
        error_secure_context_required: "Hitilafu: Muktadha salama unahitajika (HTTPS, localhost)",
        error_camera_in_use: "Hitilafu: Kamera inatumika",
        error_camera_install_incorrect: "Hitilafu: Usakinishaji wa kamera si sahihi",
        error_browser_not_support_stream_api: "Hitilafu: Kivinjari hiki hakiungi mkono API ya video",
        recognition_error: "Hitilafu ya utambuzi",
        information_not_complete: "Taarifa hazijakamilika",
        thank_you_feedback: "Asante kwa maoni yako",
        feedback_submission_failed: "Imeshindwa kutuma maoni",
        applied: "Imetumika",
        fail: "Imeshindwa",
        choose_picture: "Chagua picha",
        error_get_details_failed: "Imeshindwa kupata maelezo",
        save_success: "Imehifadhiwa kwa mafanikio",
        association_failed: "Muunganisho umeshindwa",
        zoom_in: "Kuza",
        zoom_out: "Punguza",
        zoom: "Kuza / Punguza",
        
        // 新增缺失的翻译项
        thank_you_for_your_feedback: "Asante kwa maoni yako",
        feedback_submission_failed: "Imeshindwa kutuma maoni",
        recently_deleted: "Zilizofutwa hivi karibuni",
        no_space_selected: "Hakuna nafasi iliyochaguliwa",
        continuous_laying_quote: '"Uwekaji endelevu"',
        length: "Urefu",
        width: "Upana",
        in_total: "Jumla",
        total: "Jumla",
        no_data_yet: "Hakuna data kwa sasa",
        restore: "Rejesha",
        clear: "Futa",
        search_product_name: "Tafuta jina la bidhaa",
        setup: "Mipangilio",
        log_out: "Toka",
        personal_info: "Taarifa binafsi",
        account_security: "Usalama wa akaunti",
        change_password: "Badilisha nenosiri",
        enter_first_name: "Weka jina lako la kwanza",
        enter_last_name: "Weka jina lako la mwisho",
        location: "Mahali",
        select_country_province_city: "Chagua Nchi / Mkoa / Jiji",
        select_gender: "Chagua jinsia yako",
        user_info_changed_save: "Taarifa za mtumiaji zimebadilika, ungependa kuhifadhi?",
        switching_countries_requires_re_registering2: "Kubadilisha nchi kunahitaji kusajili upya akaunti yako",
        sort: "Panga",
        browsing_type: "Aina ya kuvinjari",
        content: "Maudhui",
        offline: "Nje ya mtandao",
        time_new_old: "Muda (mpya hadi ya zamani)",
        time_old_new: "Muda (ya zamani hadi mpya)",
        views_most_least: "Mitazamo (mingi hadi michache)",
        views_least_most: "Mitazamo (michache hadi mingi)",
        online_browsing: "Kuvinjari mtandaoni",
        return: "Rudi",
        unlocked: "Imefunguliwa",
        not_unlocked: "Haijafunguliwa",
        rating: "Kiwango",
        course_introduce: "Utangulizi wa kozi",
        tap_star_to_score: "Gusa nyota ili kutoa alama",
        what_think_of_course: "Unafikiria nini kuhusu kozi?",
        take_an_exam: "Fanya mtihani",
        points: "Alama",
        today: "Leo",
        before: "Kabla",
        min: "Dk",
        learn: "Jifunze",
        learned: "Vimejifunzwa", // 已学
        template: "<kielezo>",
        list_of_the: "Orodha ya",
        year: "Mwaka",
        month: "Mwezi",
        period_of_statistics: "Kipindi cha takwimu",
        annual: "Kila mwaka",
        monthly: "Kila mwezi",
        no_more: "Hakuna zaidi",
        by_date: "kwa tarehe",
        budget: "Bajeti",
        overall_points_ranking: "Nafasi ya jumla ya pointi",
        learning_points_ranking: "Nafasi ya pointi za kujifunza",
        lecturers_points_ranking: "Nafasi ya pointi za wahadhiri",
        course_scoring_ranking: "Nafasi ya alama za kozi",
        january: "Januari",
        february: "Februari",
        march: "Machi",
        april: "Aprili",
        may: "Mei",
        june: "Juni",
        july: "Julai",
        august: "Agosti",
        september: "Septemba",
        october: "Oktoba",
        november: "Novemba",
        december: "Desemba",
        category: "Jamii",
        all_course: "Kozi zote",
        determine_all_historical_records: "Onyesha rekodi zote za kihistoria",
        search_for_all: "Tafuta zote",
        lecturer: "Mkufunzi",
        application: "Maombi",
        application_process: "1.Wasilisha data – 2. Subiri mapitio – 3. Wasiliana na mtu ikiwa mapitio yamefaulu",
    },
    // 商学院翻译
    business_school: {
        business_school: 'École de Commerce',
        become_lecturer: 'Devenir Formateur',
        category: 'Catégorie',
        all_course: 'Tous les cours',
        my_learning: 'Mes apprentissages',
        ranking: 'Classement',
        learning_history: 'Historique d’apprentissage',
        all: 'Tout',
        favorite: 'Favoris',
        
        // 新增商学院相关翻译项
        unfortunately_there_are_no: 'Kwa makosa, hakuna',
        relevant_results: 'Matokeo Yanayohusiana',
        selected_all: "Yote Yamechaguliwa",
        removed: "Imefutwa",
        please_select_at_least_one_course_to_remove: "Tafadhali chagua angalau course moja kuchafua",
        removed_successfully: "Imefutwa Kufanikiwa",
        course: "Course",
        take_exam: "Fanya mtihani",
        course_intro: "Utangulizi wa kozi",
        tap_star_to_score: "Gusa nyota ili kutoa alama",
        what_do_you_think_of_course: "Unafikiria nini kuhusu kozi?",
        thank_you_for_feedback: "Asante kwa maoni yako",
        failed_to_submit_feedback: "Imeshindwa kutuma maoni",
        points: "Alama",
        today: "Leo",
        before: "Kabla",
        min: "Dk",
        learn: "Jifunze",
        learned: "Vimejifunzwa", // 已学
        list_of_the: "Orodha ya",
        year: "Mwaka",
        month: "Mwezi",
        period_of_statistics: "Kipindi cha takwimu",
        annual: "Kila mwaka",
        monthly: "Kila mwezi",
        no_more: "Hakuna zaidi",
        by_date: "kwa tarehe",
        budget: "Bajeti",
        overall_points_ranking: "Nafasi ya jumla ya pointi",
        learning_points_ranking: "Nafasi ya pointi za kujifunza",
        lecturers_points_ranking: "Nafasi ya pointi za wahadhiri",
        course_scoring_ranking: "Nafasi ya alama za kozi",
        january: "Januari",
        february: "Februari",
        march: "Machi",
        april: "Aprili",
        may: "Mei",
        june: "Juni",
        july: "Julai",
        august: "Agosti",
        september: "Septemba",
        october: "Oktoba",
        november: "Novemba",
        december: "Desemba",
        lecturer: "Mkufunzi",
        application: "Maombi",
        application_process: "1.Wasilisha data – 2. Subiri mapitio – 3. Wasiliana na mtu ikiwa mapitio yamefaulu",
        applied: "Imetumika",
        fail: "Imeshindwa",
    }
}

export default sw;


// WEBPACK FOOTER //
// ./src/VueI18n/sw.js